import { Injectable, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, interval, Subject, takeUntil } from 'rxjs';
import { TimeOfDay, TimeOfDayType } from './page-gradient.config';

@Injectable({
  providedIn: 'root',
})
export class TimeOfDayService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly timeOfDaySubject = new BehaviorSubject<TimeOfDayType>(TimeOfDay());

  readonly changed$ = this.timeOfDaySubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      interval(10000)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.checkTimeOfDay());
    }
  }

  get currentTimeOfDay(): TimeOfDayType {
    return this.timeOfDaySubject.value;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private checkTimeOfDay(): void {
    const nextTimeOfDay = TimeOfDay();
    if (nextTimeOfDay !== this.timeOfDaySubject.value) {
      this.timeOfDaySubject.next(nextTimeOfDay);
    }
  }
}
